import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-list_view",
  "use": "icon-list_view-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"icon-list_view\">\n<rect x=\"2\" y=\"2\" width=\"4\" height=\"4\" />\n<rect x=\"9\" y=\"2\" width=\"13\" height=\"4\" />\n<rect x=\"2\" y=\"10\" width=\"4\" height=\"4\" />\n<path d=\"M9,14h13v-4H9V14z\" />\n<rect x=\"2\" y=\"18\" width=\"4\" height=\"4\" />\n<rect x=\"9\" y=\"18\" width=\"13\" height=\"4\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol